export default __webpack_public_path__ + "static/media/structure_ML_projects.214c5c70.png";